import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../api-config";

const POSTS_PER_PAGE = 6;

const BlogPost = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const fetchPosts = async () => {
    try {
      const response = await axios.get(`${API_URL}/trading-api/charts/postlist`, {
        headers: { Accept: "application/json" },
      });

      const sortedPosts = response.data.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      setPosts(sortedPosts);
    } catch (error) {
      console.error("Error al obtener los posts:", error);
      alert("Hubo un problema al cargar los posts.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  const handlePostClick = (id) => {
    navigate(`/posts/${id}`);
  };

  const filteredPosts = posts.filter(
    (post) =>
      post.id.toString().includes(filter.toLowerCase()) ||
      new Date(post.created_at).toLocaleString().includes(filter)
  );

  const totalPages = Math.ceil(filteredPosts.length / POSTS_PER_PAGE);
  const displayedPosts = filteredPosts.slice(
    (currentPage - 1) * POSTS_PER_PAGE,
    currentPage * POSTS_PER_PAGE
  );

  return (
    <div className="min-h-screen bg-[#0f1523] text-white p-6 relative flex flex-col items-center">
      {/* Botón Crear */}
      <button
        onClick={() => navigate("/posts/create")}
        className="absolute top-4 right-4 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-xl shadow-md transition flex items-center gap-2"
      >
        <span className="text-xl font-bold">+</span>
        <span className="font-medium">Añadir Post</span>
      </button>

      <h1 className="text-4xl font-bold text-center mb-10">Lista de Posts</h1>

      {/* Filtros */}
      <div className="w-1/2 mx-auto mb-6">
        <input
          type="text"
          placeholder="Filtrar por ID o Fecha"
          className="w-full p-3 rounded-lg bg-gray-700 text-white placeholder-gray-400"
          value={filter}
          onChange={(e) => {
            setFilter(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      {/* Tarjetas */}
      <div className="w-1/2  flex flex-wrap justify-center gap-4">
        {loading ? (
          <p className="text-center text-gray-300 w-full">Cargando posts...</p>
        ) : displayedPosts.length === 0 ? (
          <p className="text-center text-gray-300 w-full">No hay posts disponibles.</p>
        ) : (
          displayedPosts.map((post) => (
            <div
              key={post.id}
              onClick={() => handlePostClick(post.id)}
              className="w-[280px] h-[160px] bg-gray-800 rounded-xl p-4 shadow-lg cursor-pointer hover:ring-2 hover:ring-green-400 transition"
            >
              <p className="text-sm text-gray-400 mb-2">
                {new Date(post.created_at).toLocaleString()}
              </p>
              <p className="text-lg font-semibold text-white">Post ID: {post.id}</p>
            </div>
          ))
        )}
      </div>

      {/* Paginación */}
      <div className="flex justify-center items-center mt-10 gap-4 text-white">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => prev - 1)}
          className="px-4 py-2 bg-gray-600 rounded hover:bg-gray-500 disabled:opacity-30"
        >
          Anterior
        </button>
        <span className="text-lg font-semibold">
          Página {currentPage} de {totalPages}
        </span>
        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((prev) => prev + 1)}
          className="px-4 py-2 bg-gray-600 rounded hover:bg-gray-500 disabled:opacity-30"
        >
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default BlogPost;
